/**
 * The types of notification we can show
 */
export var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["INFO"] = "info";
    NotificationTypes["SUCCESS"] = "success";
    NotificationTypes["WARNING"] = "warning";
    NotificationTypes["ERROR"] = "error";
})(NotificationTypes || (NotificationTypes = {}));
export var DialogResponseCode;
(function (DialogResponseCode) {
    DialogResponseCode[DialogResponseCode["NEGATIVE"] = 0] = "NEGATIVE";
    DialogResponseCode[DialogResponseCode["POSITIVE"] = 1] = "POSITIVE";
})(DialogResponseCode || (DialogResponseCode = {}));
export var DialogType;
(function (DialogType) {
    DialogType["INFO"] = "info";
    DialogType["SUCCESS"] = "success";
    DialogType["WARNING"] = "warning";
    DialogType["ERROR"] = "error";
    DialogType["CONFIRM"] = "confirm";
    DialogType["INPUT"] = "input";
})(DialogType || (DialogType = {}));
/**
 * The type of mode the user is using the app for. Most application doesn't need to use this state but it can be used when an application have
 * different mode for different user.
 *
 * MANAGE DATA - The user uses the app for managing the project. In this mode, the user can have more access and control. The user can
 *               create/edit/delete things.
 *
 * VIEW DATA - The user uses the app for viewing project data. In this mode, the user usually have less access. The user can only view data but
 *             don't have access to change anything.
 *
 * The UIState only provide a way to keep track of the user's usage mode but not how it is implemented. It is up to the application that uses the
 * UIState to do what it is supposed to do.
 */
export var UsageMode;
(function (UsageMode) {
    UsageMode["MANAGE_DATA"] = "manage data";
    UsageMode["VIEW_DATA"] = "view data";
})(UsageMode || (UsageMode = {}));
/**
 * The location where the slide out panel should be slide out from. This location can be different each time we show the
 * slide out panel, it doesn't have to be the same location every time.
 */
export var SlideOutPanelLocation;
(function (SlideOutPanelLocation) {
    SlideOutPanelLocation["LEFT"] = "left";
    SlideOutPanelLocation["RIGHT"] = "right";
    SlideOutPanelLocation["TOP"] = "top";
    SlideOutPanelLocation["BOTTOM"] = "bottom";
})(SlideOutPanelLocation || (SlideOutPanelLocation = {}));
